import {
    WORKSPACE_MANUFACTURER_SELECTED_KEY,
    WorkspaceManufacturerSelected,
} from 'shared/utils/workspaceUtils'

export interface ExtractedElementIds {
    elementId: string | null
    nodeId: string | null
    source: 'service-worker' | 'message' | 'fallback'
}

/**
 * Extracts elementId and nodeId from service worker message data
 * Prioritizes elementId from addManufacturerProductListingElements.updatedInput.elementId
 * Falls back to workspaceManufacturerSelectedState values
 */
export const extractElementIds = (data: any): ExtractedElementIds => {
    // Primary source: service worker addManufacturerProductListingElements response
    const elementIdFromServiceWorker =
        data?.addManufacturerProductListingElements?.updatedInput?.elementId

    if (elementIdFromServiceWorker) {
        return {
            elementId: elementIdFromServiceWorker,
            nodeId: data?.addManufacturerProductListingElements?.updatedInput?.nodeId || null,
            source: 'service-worker',
        }
    }

    // Fallback: get from workspace manufacturer selected state
    const workspaceState = data?.[
        WORKSPACE_MANUFACTURER_SELECTED_KEY
    ] as WorkspaceManufacturerSelected

    if (workspaceState) {
        return {
            elementId: workspaceState.elementId || null,
            nodeId: workspaceState.nodeId || null,
            source: 'message',
        }
    }

    return {
        elementId: null,
        nodeId: null,
        source: 'fallback',
    }
}